(() => {
  if (window.CBHCollectionGridGuard) return;

  const containerObservers = new WeakMap();
  let refreshQueued = false;

  const directProductItems = (grid) =>
    Array.from(grid?.children || []).filter((item) => item.matches?.('[data-product-id]'));

  const dedupeGrid = (scope = document) => {
    const grids = scope.matches?.('#product-grid')
      ? [scope]
      : Array.from(scope.querySelectorAll?.('#product-grid') || []);

    grids.forEach((grid) => {
      const seen = new Set();
      let removed = 0;

      directProductItems(grid).forEach((item) => {
        const productId = item.dataset.productId?.trim();
        if (!productId) return;

        if (seen.has(productId)) {
          item.remove();
          removed += 1;
          return;
        }

        seen.add(productId);
      });

      directProductItems(grid).forEach((item, index) => {
        if (item.hasAttribute('data-cascade')) {
          item.style.setProperty('--animation-order', String(index + 1));
        }
      });

      grid.dataset.cbhRenderedProducts = String(seen.size);

      if (removed > 0) {
        document.dispatchEvent(
          new CustomEvent('cbh:collection:duplicates-removed', {
            detail: { removed, rendered: seen.size },
          })
        );
      }
    });
  };

  const clearExpiredLoadingState = (scope = document, force = false) => {
    const containers = scope.matches?.('#ProductGridContainer')
      ? [scope]
      : Array.from(scope.querySelectorAll?.('#ProductGridContainer') || []);

    containers.forEach((container) => {
      const started = Number(container.dataset.cbhLoadingStarted || 0);
      const expired = started > 0 && Date.now() - started > 15000;

      if (!force && !expired) return;

      container.classList.remove('loading');
      container.removeAttribute('aria-busy');
      delete container.dataset.cbhLoadingStarted;
      container.querySelectorAll('.collection.loading').forEach((collection) => {
        collection.classList.remove('loading');
      });
    });
  };

  const observeContainer = (container) => {
    if (!container || containerObservers.has(container)) return;

    const observer = new MutationObserver(() => queueRefresh(container));
    observer.observe(container, { childList: true, subtree: true });
    containerObservers.set(container, observer);
  };

  const cleanupScope = (scope) => {
    if (!scope) return;

    const containers = scope.matches?.('#ProductGridContainer')
      ? [scope]
      : Array.from(scope.querySelectorAll?.('#ProductGridContainer') || []);

    containers.forEach((container) => {
      const observer = containerObservers.get(container);
      observer?.disconnect();
      containerObservers.delete(container);
    });
  };

  const refresh = (scope = document) => {
    dedupeGrid(scope);

    const containers = scope.matches?.('#ProductGridContainer')
      ? [scope]
      : Array.from(scope.querySelectorAll?.('#ProductGridContainer') || []);

    containers.forEach(observeContainer);
    clearExpiredLoadingState(scope);
  };

  const queueRefresh = (scope = document) => {
    if (refreshQueued) return;
    refreshQueued = true;

    window.requestAnimationFrame(() => {
      refreshQueued = false;
      refresh(scope);
    });
  };

  window.CBHCollectionGridGuard = {
    refresh,
    clearLoading: (scope = document) => clearExpiredLoadingState(scope, true),
  };

  document.addEventListener('cbh:collection:updated', () => queueRefresh(document));
  document.addEventListener('shopify:section:load', (event) => queueRefresh(event.target));
  document.addEventListener('shopify:section:unload', (event) => cleanupScope(event.target));

  window.addEventListener('pageshow', () => {
    clearExpiredLoadingState(document, true);
    queueRefresh(document);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => refresh(document), { once: true });
  } else {
    refresh(document);
  }
})();
